import { styled } from "@mui/material/styles";

export const InputWrapper = styled("div")({
  paddingTop: "15px",
});
